module.exports = __webpack_public_path__ + "static/media/bokuNoHeroLofi.19238686.mp3";